// Indian currency formatter
export const formatINR = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(amount || 0);
};

// Format number with Indian numbering (no ₹)
export const formatINRNumber = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: 0,
  }).format(amount || 0);
};

// Indian states list
export const INDIAN_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
  'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
  'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
  'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
  'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Delhi', 'Jammu and Kashmir',
];

// PT Slabs
export const PT_SLABS = {
  Maharashtra: { rule: '₹200/month above ₹10,000 gross', getDeduction: (g) => (g > 10000 ? 200 : 0) },
  Karnataka: { rule: '₹200/month above ₹15,000 gross', getDeduction: (g) => (g > 15000 ? 200 : 0) },
  'West Bengal': { rule: '₹110/month flat (all earners)', getDeduction: () => 110 },
};

export const getPTDeduction = (state, gross) => {
  const slab = PT_SLABS[state];
  if (!slab) return 0;
  return slab.getDeduction(gross);
};

export const getPTRule = (state) => {
  const slab = PT_SLABS[state];
  return slab ? slab.rule : 'PT not applicable';
};

// Payroll calculation logic
export const calculatePayroll = (employee, attendance, workingDays = 26) => {
  const { basic, hra, allowances, pf, esi } = employee;
  const present = attendance?.present ?? workingDays;
  const halfDays = attendance?.halfDays ?? 0;
  const lopDays = attendance?.lopDays ?? 0;
  const overtime = attendance?.overtime ?? 0;
  const bonus = attendance?.bonus ?? 0;

  const gross = basic + hra + allowances + overtime + bonus;
  const lopDeduction = Math.round((basic / workingDays) * lopDays);
  const pfDeduction = pf ? Math.round(basic * 0.12) : 0;
  const esiDeduction = esi && gross < 21000 ? Math.round(gross * 0.0075) : 0;
  const netPay = gross - lopDeduction - pfDeduction - esiDeduction;

  return {
    daysPresent: present,
    halfDays,
    lopDays,
    basic,
    hra,
    allowances,
    overtime,
    bonus,
    gross,
    lopDeduction,
    pfDeduction,
    esiDeduction,
    netPay,
  };
};
